export default function isSubsetOf<T>(a: Set<T>, b: Set<T>): boolean {
  for (const elem of a) {
    if (!b.has(elem)) return false
  }
  return true
}
